
export default {
  staticDomain: '//static.hsappstatic.net' || window.location.host,
  staticDomainPrefix: '//static.hsappstatic.net' || ('//' + window.location.host),
  currentProject: 'marketplace-storefront-public-ui',
  currentProjectVersion: 'static-1.11533',
  depVersions: {
  "marketplace-storefront-public-ui": "static-1.11533",
  "apollo-dlb": "static-3.80",
  "client-types": "static-1.445",
  "dashboard-client-types": "static-1.219",
  "data-fetching-client": "static-1.9471",
  "foundations-components": "static-1.7511",
  "foundations-components-legacy": "static-1.536",
  "foundations-theming": "static-1.4203",
  "googlemaps-react-wrapper": "static-1.3",
  "graphql": "static-1.77",
  "head-dlb": "static-1.4754",
  "hs-test-utils": "static-1.7798",
  "hub-http-shared-msw-handlers": "static-1.9463",
  "hubspot-dlb": "static-2.1796",
  "hubspot-url-utils": "static-1.3917",
  "HubStyleTokens": "static-2.11219",
  "I18n": "static-7.1567",
  "jasmine-runner": "static-1.6266",
  "marketplace-storefront-base": "static-1.11593",
  "quartz": "static-1.6726",
  "react-dlb": "static-1.71",
  "react-rhumb": "static-1.16441",
  "react-router-dom": "static-5.26",
  "reactive-variable-buffer-atom": "static-1.2654",
  "reporting-testing-lib": "static-1.8419",
  "settings-ui-lib": "static-1.12315",
  "SharedI18nStrings": "static-1.180",
  "signup-ui-core": "static-1.10391",
  "source-map": "static-1.4",
  "trellis-ecosystem": "static-1.6716",
  "ui-addon-i18n": "static-1.10931",
  "ui-addon-react-router-dom": "static-1.9340",
  "unified-auth": "static-1.199",
  "unified-auth-core-lib": "static-1.480",
  "usage-tracker": "static-1.7128",
  "usage-tracker-core": "static-1.6978",
  "customer-data-property-utils": "static-1.7869",
  "history": "static-4.47",
  "hub-http": "static-1.5966",
  "integrations-lib": "static-1.15391",
  "marketplace-ui-common": "static-1.18918",
  "property-management-iframe": "static-1.12312",
  "quartz-config": "static-1.504",
  "quartz-core": "static-1.5945",
  "quartz-routing": "static-1.156",
  "quick-fetch": "static-1.3728",
  "react": "static-7.177",
  "rpc-client-utils": "static-1.4426",
  "ts-schema": "static-1.3897",
  "ui-universal-auth": "static-1.8685",
  "UIComponents": "static-3.8166",
  "apollo-stack-hubspot": "static-3.79",
  "enviro": "static-4.387",
  "hs-promise-rejection-tracking": "static-1.5291",
  "PortalIdParser": "static-2.349",
  "raven": "static-3.5624",
  "raven-hubspot": "static-1.5931",
  "classnames": "static-2.10",
  "hoist-non-react-statics": "static-3.9",
  "immutable": "static-2.19",
  "metrics-js": "static-1.9391",
  "react-redux": "static-7.66",
  "redux": "static-4.16",
  "styled-components": "static-2.84",
  "bend-plugin-trellis-migration": "static-1.3221",
  "moment": "static-3.26",
  "react-dom": "static-7.85",
  "bend-plugin-quartz": "static-1.3003",
  "quartz-webpack": "static-1.2950",
  "fast-json-stable-stringify": "static-1.4",
  "bend-plugin-foundations-components": "static-1.3780",
  "floating-ui": "static-1.51",
  "foundations-assets": "static-1.4629",
  "foundations-theming-specialty": "static-1.1919",
  "framer-motion": "static-1.67",
  "hs-story-utils": "static-1.9221",
  "react-aria": "static-1.61",
  "react-select-plus": "static-1.65",
  "react-utils": "static-2.5166",
  "react-virtualized": "static-2.94",
  "StyleGuideUI": "static-3.483",
  "tanstack-table": "static-1.50",
  "trellis-assets": "static-1.1174",
  "ui-fonts": "static-1.481",
  "ui-images": "static-2.1089",
  "bend-plugin-foundations-theming": "static-1.2686",
  "foundations-theming-base": "static-1.3188",
  "stylex": "static-1.27",
  "HeadJS": "static-2.709",
  "hs-test-utils-bend-plugin": "static-1.2909",
  "msw": "static-1.39",
  "testing-library": "static-1.147",
  "webpack-env": "static-1.54",
  "i18n-data": "static-1.216",
  "moment-timezone": "static-5.78",
  "jasmine": "static-4.4120",
  "ai-components-ui-library": "static-1.8329",
  "ai-rendering-library": "static-1.9282",
  "chirp-fetch": "static-1.1676",
  "connections-embed-lib": "static-1.616",
  "copilot-toolkit": "static-1.10507",
  "laboratory-lib": "static-3.6954",
  "marketplace-embed": "static-1.21465",
  "marketplace-ui-details": "static-1.8814",
  "marketplace-ui-reviews": "static-1.18874",
  "marketplace-ui-tracking": "static-1.13089",
  "sanitize-text": "static-1.7932",
  "ui-addon-video-player": "static-1.8487",
  "usage-tracker-multi": "static-1.5542",
  "usage-tracker-session-replay": "static-1.4814",
  "wootric-nps": "static-1.6776",
  "apollo-link-hub-http": "static-2.4441",
  "immer": "static-1.33",
  "immerable": "static-1.3946",
  "highcharts": "static-8.99",
  "hs-lodash": "static-4.45",
  "reporting-client-types": "static-1.2385",
  "reporting-data": "static-1.66486",
  "cssUtils": "static-1.729",
  "flux-actions": "static-1.309",
  "HubStyle": "static-2.11527",
  "PatternValidationJS": "static-1.437",
  "react-colorpicker": "static-2.10003",
  "react-dnd": "static-5.6",
  "react-dnd-html5-backend": "static-5.6",
  "redux-observable": "static-1.11",
  "ReduxMessenger": "static-2.10165",
  "rxjs": "static-5.10",
  "underscore": "static-1.8",
  "usage-tracker-container": "static-1.7118",
  "icons": "static-2.622",
  "marketplace-ui-apps-core": "static-1.17451",
  "storybook-react": "static-1.28",
  "trellis-story-utils": "static-1.4315",
  "foundations-components-test-utils": "static-1.4994",
  "quartz-i18n": "static-1.401",
  "react-input-autosize": "static-2.17",
  "fsm": "static-1.3523",
  "customer-data-objects": "static-1.7440",
  "property-translator": "static-1.5205",
  "frontend-preferences-client": "static-1.7718",
  "hs-promise-utils": "static-1.5384",
  "hubspot-apollo-client": "static-1.4673",
  "integrations-error-boundary-lib": "static-1.12806",
  "integrations-tracking-lib": "static-1.5381",
  "native-integrations-shared-strings": "static-1.7581",
  "reselect": "static-2.16",
  "sanitize": "static-1.4267",
  "superstore": "static-1.4563",
  "ui-shepherd-react": "static-3.9938",
  "ai-settings-ui-library": "static-1.7445",
  "hub-http-janus": "static-1.792",
  "hubspotter-http": "static-1.4471",
  "immutable-less": "static-1.4447",
  "marketplace-ui-client-types": "static-1.16325",
  "nav-meta": "static-1.28883",
  "react-window": "static-1.13",
  "self-service-api": "static-1.10025",
  "ui-addon-upgrades": "static-9.17645",
  "inbound-db-properties-service-client": "static-1.3668",
  "property-management-common": "static-1.4599",
  "ui-addon-iframeable": "static-1.8838",
  "dispatcher": "static-1.132",
  "general-store": "static-6.20",
  "mobile-manifest-mixins": "static-1.482",
  "module-federation": "static-1.18",
  "quartz-auth": "static-1.401",
  "quartz-head": "static-1.391",
  "quartz-test": "static-1.401",
  "quartz-tracking": "static-1.105",
  "csstype": "static-1.50",
  "bender-build-tools": "static-1.2937",
  "autolinker": "static-3.11",
  "chatspot-core": "static-1.20273",
  "ContentUtils": "static-1.67601",
  "sassPrefix": "static-1.151",
  "avatar-components": "static-1.2278",
  "customer-data-filters-ui": "static-1.38883",
  "customer-data-objects-ui-components": "static-1.12799",
  "customer-data-reference-ui-components": "static-1.12936",
  "embedded-academy-lib": "static-1.13499",
  "ExportDialog": "static-6.10180",
  "highlight.js": "static-1.74",
  "markdown-it": "static-1.6",
  "reporting-action-components": "static-1.40640",
  "reporting-snowflake": "static-1.55104",
  "reporting-ui-components": "static-2.63757",
  "reporting-visualizations": "static-1.58562",
  "ui-addon-teams": "static-1.21233",
  "magpie-lib": "static-1.5387",
  "magpie-types": "static-1.4847",
  "simple-logging-lib": "static-1.2842",
  "navigation-components": "static-1.17246",
  "ai-studio-lib": "static-1.10982",
  "developer-experience-shared-components": "static-1.10254",
  "transmute": "static-2.85",
  "ui-addon-integrations-directory-panel": "static-2.7782",
  "ui-tool-access": "static-1.9938",
  "usage-based-billing-components-lib": "static-1.7983",
  "usage-tracker-anonymous": "static-1.5545",
  "usage-tracker-public": "static-1.6939",
  "amplitude-session-replay-browser": "static-1.55",
  "inbound-db-meta-service-client": "static-1.3410",
  "persist-promise": "static-1.3499",
  "reference-resolvers": "static-1.7954",
  "ui-extensibility-client-types": "static-1.3738",
  "hubspot-apollo-cache": "static-1.132",
  "universal-page-editor-lib": "static-1.2792",
  "redux-toolkit": "static-1.7",
  "simple-data-table": "static-1.2169",
  "merchandise-lib": "static-1.259",
  "atom": "static-1.4862",
  "purchase-motions-components": "static-1.5476",
  "salesImages": "static-1.520",
  "batch-promise": "static-1.1342",
  "crm-component-utils": "static-1.38466",
  "crm-properties-common-lib": "static-1.5664",
  "framework-data-schema-resolvers": "static-1.6665",
  "reference-resolvers-lite": "static-1.7887",
  "navigation-messaging": "static-1.6573",
  "hubspotter-http-shared-msw-handlers": "static-1.9461",
  "cms-field-types": "static-1.4598",
  "content-icons-ui": "static-1.2151",
  "conversations-skeleton-state": "static-1.7041",
  "crm-message-bus": "static-1.42344",
  "customer-data-filters-ui-msw-helpers": "static-1.21317",
  "customer-data-ui-utilities": "static-1.9617",
  "FormUrlGenerator": "static-2.4522",
  "framework-builder-read-service-client": "static-1.3826",
  "framework-data-schema-quick-fetch": "static-1.6570",
  "multi-account-reference-resolvers": "static-1.767",
  "onboarding-tours": "static-1.16248",
  "react-immutable-proptypes": "static-2.8",
  "reporting-datasets-permissions-lib": "static-1.13018",
  "academy-common-lib": "static-1.12959",
  "content-assistance-lib": "static-1.7438",
  "dashboard-lib": "static-1.80601",
  "file-manager-components": "static-1.22864",
  "getting-started-shared-tasks": "static-1.17863",
  "hubspot-prosemirror": "static-1.17586",
  "hubspot-prosemirror-plugins": "static-1.17578",
  "prosemirror": "static-1.13",
  "rich-text-lib": "static-1.19458",
  "share-with-third-party-component-lib": "static-1.8484",
  "ui-addon-draggable": "static-3.4558",
  "ui-asset-management-lib": "static-1.10700",
  "ui-business-units-lib": "static-1.8819",
  "user-context": "static-1.4889",
  "growth-payments-core": "static-1.24709",
  "reporting-plugins": "static-1.9974",
  "reporting-reports": "static-1.66164",
  "idb-keyval": "static-1.39",
  "reactive-lib": "static-1.518",
  "codemirror": "static-5.90",
  "feedback-loader": "static-1.28842",
  "react-codemirror": "static-1.10419",
  "apps-service-types": "static-1.3670",
  "oauth-service-types": "static-1.4034",
  "onboarding-scopes": "static-1.6255",
  "onboarding-tours-client": "static-1.4462",
  "platform-infra-nav-components": "static-1.7485",
  "subscription-experience-data-types": "static-1.14579",
  "crm-record-cards-service-types": "static-1.3445",
  "location-customization-utils-lib": "static-1.8539",
  "redux-thunk": "static-2.43",
  "growth-monetization-service-types": "static-1.4307",
  "nav-client-types": "static-1.2149",
  "purchase-motions-api": "static-1.5479",
  "signup-constants": "static-1.18376",
  "signup-ui-url-generator": "static-2.7858",
  "trials-service-types": "static-1.3708",
  "card-properties-lib": "static-1.43500",
  "crm-actions": "static-1.6093",
  "crm-cards-data": "static-1.1195",
  "crm-cards-sdk": "static-1.42897",
  "customer-data-properties": "static-1.50782",
  "customer-data-properties-shared-msw-handlers": "static-1.8790",
  "customer-data-tracking": "static-1.6673",
  "conditional-properties-service-client": "static-1.3616",
  "crm-pipelines-api-client-types": "static-1.3957",
  "multi-currency-client-types": "static-1.3510",
  "external-options-client-types": "static-1.3977",
  "react-dnd-compat": "static-1.4414",
  "react-immutable-render-mixin": "static-1.9",
  "growth-data-modal": "static-1.5147",
  "growth-onboarding-confetti": "static-1.2863",
  "growth-onboarding-next-action-utils": "static-1.1293",
  "onboarding-tours-utils": "static-1.314",
  "ui-shepherd-tracker": "static-1.7319",
  "academy-service-client": "static-1.3473",
  "final-form": "static-1.65",
  "zustand": "static-1.51",
  "ui-coaching-tips": "static-1.27925",
  "redux-actions": "static-3.7",
  "ui-addon-opt": "static-4.8178",
  "video-components-external": "static-1.10542",
  "video-data-lib": "static-1.34200",
  "emoji-mart": "static-3.4",
  "knowledge-content-types": "static-1.8361",
  "payment-link-components": "static-1.22923",
  "ui-addon-emoji-picker": "static-1.9681",
  "EmailSignatureEditor": "static-1.23894",
  "viral-links-lib": "static-1.6825",
  "data-token-picker": "static-1.16030",
  "FileManagerLib": "static-1.38504",
  "react-flip-move": "static-1.65",
  "timezone-utils": "static-2.5037",
  "getting-started-shared-tasks-store": "static-1.16981",
  "campaign-roi-lib": "static-1.8254",
  "diff-match-patch": "static-1.7",
  "browser-eslint": "static-2.57",
  "edison-service-client-types": "static-1.182",
  "eligibility-engine-service-types": "static-1.2989",
  "crm_data": "static-4.91193",
  "crm-links": "static-1.6056",
  "customer-data-sidebar": "static-2.45400",
  "enrichment-properties-lib": "static-1.15003",
  "crm-fe-perf": "static-1.22697",
  "calling-global-api": "static-1.63644",
  "calling-internal-common": "static-1.31086",
  "calling-lifecycle-internal": "static-1.65026",
  "calling-lifecycle-messages": "static-1.57320",
  "commerce-products-lib": "static-1.8845",
  "google-libphonenumber": "static-1.33",
  "hs-entities": "static-1.470",
  "inbounddb-objects-service-types": "static-1.4042",
  "meetings-icalendar-utils-lib": "static-1.425",
  "object-builder-ui-client": "static-1.47948",
  "pipeline-validation-client-types": "static-1.3779",
  "property-value-citations": "static-1.1396",
  "pulse": "static-1.303",
  "smart-property-lib": "static-1.5885",
  "tiered-pricing": "static-1.820",
  "ui-addon-form-validation": "static-1.10787",
  "growth-onboarding-feedback-components": "static-1.6377",
  "content-media-composition-data-lib": "static-1.11428",
  "content-media-compositions": "static-2.15435",
  "media-bridge-lib": "static-1.18553",
  "commerce-tours-lib": "static-1.5709",
  "growth-onboarding-reliability": "static-1.4879",
  "sales-checkout-service-client": "static-1.3462",
  "draft-convert": "static-2.67",
  "draft-extend": "static-3.70",
  "draft-js": "static-5.72",
  "draft-plugins": "static-2.21296",
  "sales-email-signature-service-client": "static-1.3637",
  "audio-components": "static-1.5602",
  "FileManagerCore": "static-1.38363",
  "FileManagerImages": "static-1.36015",
  "video-components": "static-1.12545",
  "crm_universal": "static-1.21649",
  "customer-data-email": "static-1.17659",
  "calling-error-reporting": "static-1.31092",
  "card-payment-highlight-lib": "static-1.36485",
  "card-subscription-highlight-lib": "static-1.38841",
  "commerce-billing-lib": "static-1.18483",
  "commerce-contract-lib": "static-1.11158",
  "customer-data-content": "static-1.26859",
  "invoices-highlight-card-lib": "static-1.54004",
  "orders-highlight-card-lib": "static-1.20851",
  "products-highlight-card-lib": "static-1.17129",
  "project-storage": "static-1.4524",
  "quotes-highlight-card-lib": "static-1.71152",
  "breeze-intelligence-kit": "static-1.5311",
  "crm-source-interpretation-lib": "static-1.5121",
  "framework-data-schema-resolvers-shared-msw-handlers": "static-1.9546",
  "policy-lib": "static-1.6578",
  "shared-worker-versioning": "static-1.10830",
  "calling-usage-tracker": "static-1.6332",
  "voice-sms-access-library": "static-1.224",
  "products-iframe-lib": "static-1.7294",
  "products-ui-components-shared-msw-handlers": "static-1.9845",
  "directed-graph": "static-1.730",
  "event-emitter": "static-1.740",
  "react-tinymce": "static-1.54598",
  "reference-resolvers-lite-shared-msw-handlers": "static-1.9609",
  "tinymce": "static-5.11",
  "tinymce-config": "static-2.53724",
  "tinymce-plugins": "static-1.56838",
  "tinymce-themes": "static-1.55694",
  "hls.js": "static-1.34",
  "js-cookie": "static-1.18",
  "cropperjs": "static-1.10",
  "urlinator": "static-1.4325",
  "video-embed": "static-1.35034",
  "social-insights-client-types": "static-1.21303",
  "sequences-lib": "static-1.7679",
  "ui-gdpr-components": "static-1.10140",
  "commerce-shared-components-lib": "static-1.17898",
  "commerce-subscription-lib": "static-1.36418",
  "commerce-tools-ui-lib": "static-1.9774",
  "utility-belt": "static-1.2334",
  "payments-enrollment-embed-lib": "static-1.22007",
  "products-ui-components": "static-1.39364",
  "quotes-client-types": "static-1.37240",
  "quotes-ui-lib": "static-1.79871",
  "SalesContentIndexUI": "static-3.8892",
  "accounting-integrations-ui-components": "static-1.6713",
  "invoices-ui-lib": "static-1.54020",
  "commerce-products-api": "static-1.1948",
  "SafeStorage": "static-1.4197",
  "invoices-iframe-lib": "static-1.56078",
  "quotes-modal-lib": "static-1.101828",
  "calling-orchestration-schema": "static-1.35001",
  "sales-views-client-types": "static-1.4080",
  "hub-http-contrib": "static-1.2837",
  "interframe": "static-3.4583",
  "tinymce-data": "static-1.39809",
  "ui-addon-sales-email": "static-1.5006",
  "layout-dnd-components": "static-1.12021",
  "layout-dnd-utils": "static-1.10996",
  "ui-brand-identity-lib": "static-1.13853",
  "NamespacedHubStyle": "static-2.8889",
  "outpost": "static-1.3998",
  "sequences-client-types-lib": "static-1.7536",
  "customer-data-associations": "static-1.7130",
  "framework-data-table": "static-2.11399",
  "customer-data-rte": "static-1.32427",
  "cv-backend-services": "static-1.1504",
  "growth-onboarding-empty-states": "static-1.5354",
  "InboxConnectUtils": "static-4.14207",
  "payments-post-enroll-local-storage-lib": "static-1.4904",
  "qrcode-generator": "static-1.64",
  "stripe-embedded-components": "static-1.7122",
  "commerce-permissions": "static-1.547",
  "commerce-tax-lib": "static-1.310",
  "property-description-translator": "static-1.3651",
  "FireAlarmUi": "static-1.4322",
  "sales-templates-service-types-lib": "static-1.3984",
  "commerce-analytics-service-client": "static-1.3450",
  "totals-ui-components": "static-1.22981",
  "ContentData": "static-1.67676",
  "layout-data-lib": "static-1.9321",
  "deal-intel-decorators": "static-1.1238",
  "tanstack-virtual": "static-1.25",
  "draft-content-plugins": "static-1.27696",
  "stripe-connect-js": "static-1.64",
  "commerce-totals-service-types": "static-1.3630",
  "advanced-menus-core": "static-1.14804",
  "advanced-menus-lib": "static-1.11779",
  "ui-memberships-settings-lib": "static-1.33408",
  "deal-intel-utils": "static-1.1242",
  "seamless-immutable": "static-7.6",
  "simple-menus-core": "static-1.14803",
  "simple-menus-lib": "static-1.16320"
},
  depPathPrefixes: {
  "marketplace-storefront-public-ui": "/marketplace-storefront-public-ui/static-1.11533",
  "apollo-dlb": "/apollo-dlb/static-3.80",
  "client-types": "/client-types/static-1.445",
  "dashboard-client-types": "/dashboard-client-types/static-1.219",
  "data-fetching-client": "/data-fetching-client/static-1.9471",
  "foundations-components": "/foundations-components/static-1.7511",
  "foundations-components-legacy": "/foundations-components-legacy/static-1.536",
  "foundations-theming": "/foundations-theming/static-1.4203",
  "googlemaps-react-wrapper": "/googlemaps-react-wrapper/static-1.3",
  "graphql": "/graphql/static-1.77",
  "head-dlb": "/head-dlb/static-1.4754",
  "hs-test-utils": "/hs-test-utils/static-1.7798",
  "hub-http-shared-msw-handlers": "/hub-http-shared-msw-handlers/static-1.9463",
  "hubspot-dlb": "/hubspot-dlb/static-2.1796",
  "hubspot-url-utils": "/hubspot-url-utils/static-1.3917",
  "HubStyleTokens": "/HubStyleTokens/static-2.11219",
  "I18n": "/I18n/static-7.1567",
  "jasmine-runner": "/jasmine-runner/static-1.6266",
  "marketplace-storefront-base": "/marketplace-storefront-base/static-1.11593",
  "quartz": "/quartz/static-1.6726",
  "react-dlb": "/react-dlb/static-1.71",
  "react-rhumb": "/react-rhumb/static-1.16441",
  "react-router-dom": "/react-router-dom/static-5.26",
  "reactive-variable-buffer-atom": "/reactive-variable-buffer-atom/static-1.2654",
  "reporting-testing-lib": "/reporting-testing-lib/static-1.8419",
  "settings-ui-lib": "/settings-ui-lib/static-1.12315",
  "SharedI18nStrings": "/SharedI18nStrings/static-1.180",
  "signup-ui-core": "/signup-ui-core/static-1.10391",
  "source-map": "/source-map/static-1.4",
  "trellis-ecosystem": "/trellis-ecosystem/static-1.6716",
  "ui-addon-i18n": "/ui-addon-i18n/static-1.10931",
  "ui-addon-react-router-dom": "/ui-addon-react-router-dom/static-1.9340",
  "unified-auth": "/unified-auth/static-1.199",
  "unified-auth-core-lib": "/unified-auth-core-lib/static-1.480",
  "usage-tracker": "/usage-tracker/static-1.7128",
  "usage-tracker-core": "/usage-tracker-core/static-1.6978",
  "customer-data-property-utils": "/customer-data-property-utils/static-1.7869",
  "history": "/history/static-4.47",
  "hub-http": "/hub-http/static-1.5966",
  "integrations-lib": "/integrations-lib/static-1.15391",
  "marketplace-ui-common": "/marketplace-ui-common/static-1.18918",
  "property-management-iframe": "/property-management-iframe/static-1.12312",
  "quartz-config": "/quartz-config/static-1.504",
  "quartz-core": "/quartz-core/static-1.5945",
  "quartz-routing": "/quartz-routing/static-1.156",
  "quick-fetch": "/quick-fetch/static-1.3728",
  "react": "/react/static-7.177",
  "rpc-client-utils": "/rpc-client-utils/static-1.4426",
  "ts-schema": "/ts-schema/static-1.3897",
  "ui-universal-auth": "/ui-universal-auth/static-1.8685",
  "UIComponents": "/UIComponents/static-3.8166",
  "apollo-stack-hubspot": "/apollo-stack-hubspot/static-3.79",
  "enviro": "/enviro/static-4.387",
  "hs-promise-rejection-tracking": "/hs-promise-rejection-tracking/static-1.5291",
  "PortalIdParser": "/PortalIdParser/static-2.349",
  "raven": "/raven/static-3.5624",
  "raven-hubspot": "/raven-hubspot/static-1.5931",
  "classnames": "/classnames/static-2.10",
  "hoist-non-react-statics": "/hoist-non-react-statics/static-3.9",
  "immutable": "/immutable/static-2.19",
  "metrics-js": "/metrics-js/static-1.9391",
  "react-redux": "/react-redux/static-7.66",
  "redux": "/redux/static-4.16",
  "styled-components": "/styled-components/static-2.84",
  "bend-plugin-trellis-migration": "/bend-plugin-trellis-migration/static-1.3221",
  "moment": "/moment/static-3.26",
  "react-dom": "/react-dom/static-7.85",
  "bend-plugin-quartz": "/bend-plugin-quartz/static-1.3003",
  "quartz-webpack": "/quartz-webpack/static-1.2950",
  "fast-json-stable-stringify": "/fast-json-stable-stringify/static-1.4",
  "bend-plugin-foundations-components": "/bend-plugin-foundations-components/static-1.3780",
  "floating-ui": "/floating-ui/static-1.51",
  "foundations-assets": "/foundations-assets/static-1.4629",
  "foundations-theming-specialty": "/foundations-theming-specialty/static-1.1919",
  "framer-motion": "/framer-motion/static-1.67",
  "hs-story-utils": "/hs-story-utils/static-1.9221",
  "react-aria": "/react-aria/static-1.61",
  "react-select-plus": "/react-select-plus/static-1.65",
  "react-utils": "/react-utils/static-2.5166",
  "react-virtualized": "/react-virtualized/static-2.94",
  "StyleGuideUI": "/StyleGuideUI/static-3.483",
  "tanstack-table": "/tanstack-table/static-1.50",
  "trellis-assets": "/trellis-assets/static-1.1174",
  "ui-fonts": "/ui-fonts/static-1.481",
  "ui-images": "/ui-images/static-2.1089",
  "bend-plugin-foundations-theming": "/bend-plugin-foundations-theming/static-1.2686",
  "foundations-theming-base": "/foundations-theming-base/static-1.3188",
  "stylex": "/stylex/static-1.27",
  "HeadJS": "/HeadJS/static-2.709",
  "hs-test-utils-bend-plugin": "/hs-test-utils-bend-plugin/static-1.2909",
  "msw": "/msw/static-1.39",
  "testing-library": "/testing-library/static-1.147",
  "webpack-env": "/webpack-env/static-1.54",
  "i18n-data": "/i18n-data/static-1.216",
  "moment-timezone": "/moment-timezone/static-5.78",
  "jasmine": "/jasmine/static-4.4120",
  "ai-components-ui-library": "/ai-components-ui-library/static-1.8329",
  "ai-rendering-library": "/ai-rendering-library/static-1.9282",
  "chirp-fetch": "/chirp-fetch/static-1.1676",
  "connections-embed-lib": "/connections-embed-lib/static-1.616",
  "copilot-toolkit": "/copilot-toolkit/static-1.10507",
  "laboratory-lib": "/laboratory-lib/static-3.6954",
  "marketplace-embed": "/marketplace-embed/static-1.21465",
  "marketplace-ui-details": "/marketplace-ui-details/static-1.8814",
  "marketplace-ui-reviews": "/marketplace-ui-reviews/static-1.18874",
  "marketplace-ui-tracking": "/marketplace-ui-tracking/static-1.13089",
  "sanitize-text": "/sanitize-text/static-1.7932",
  "ui-addon-video-player": "/ui-addon-video-player/static-1.8487",
  "usage-tracker-multi": "/usage-tracker-multi/static-1.5542",
  "usage-tracker-session-replay": "/usage-tracker-session-replay/static-1.4814",
  "wootric-nps": "/wootric-nps/static-1.6776",
  "apollo-link-hub-http": "/apollo-link-hub-http/static-2.4441",
  "immer": "/immer/static-1.33",
  "immerable": "/immerable/static-1.3946",
  "highcharts": "/highcharts/static-8.99",
  "hs-lodash": "/hs-lodash/static-4.45",
  "reporting-client-types": "/reporting-client-types/static-1.2385",
  "reporting-data": "/reporting-data/static-1.66486",
  "cssUtils": "/cssUtils/static-1.729",
  "flux-actions": "/flux-actions/static-1.309",
  "HubStyle": "/HubStyle/static-2.11527",
  "PatternValidationJS": "/PatternValidationJS/static-1.437",
  "react-colorpicker": "/react-colorpicker/static-2.10003",
  "react-dnd": "/react-dnd/static-5.6",
  "react-dnd-html5-backend": "/react-dnd-html5-backend/static-5.6",
  "redux-observable": "/redux-observable/static-1.11",
  "ReduxMessenger": "/ReduxMessenger/static-2.10165",
  "rxjs": "/rxjs/static-5.10",
  "underscore": "/underscore/static-1.8",
  "usage-tracker-container": "/usage-tracker-container/static-1.7118",
  "icons": "/icons/static-2.622",
  "marketplace-ui-apps-core": "/marketplace-ui-apps-core/static-1.17451",
  "storybook-react": "/storybook-react/static-1.28",
  "trellis-story-utils": "/trellis-story-utils/static-1.4315",
  "foundations-components-test-utils": "/foundations-components-test-utils/static-1.4994",
  "quartz-i18n": "/quartz-i18n/static-1.401",
  "react-input-autosize": "/react-input-autosize/static-2.17",
  "fsm": "/fsm/static-1.3523",
  "customer-data-objects": "/customer-data-objects/static-1.7440",
  "property-translator": "/property-translator/static-1.5205",
  "frontend-preferences-client": "/frontend-preferences-client/static-1.7718",
  "hs-promise-utils": "/hs-promise-utils/static-1.5384",
  "hubspot-apollo-client": "/hubspot-apollo-client/static-1.4673",
  "integrations-error-boundary-lib": "/integrations-error-boundary-lib/static-1.12806",
  "integrations-tracking-lib": "/integrations-tracking-lib/static-1.5381",
  "native-integrations-shared-strings": "/native-integrations-shared-strings/static-1.7581",
  "reselect": "/reselect/static-2.16",
  "sanitize": "/sanitize/static-1.4267",
  "superstore": "/superstore/static-1.4563",
  "ui-shepherd-react": "/ui-shepherd-react/static-3.9938",
  "ai-settings-ui-library": "/ai-settings-ui-library/static-1.7445",
  "hub-http-janus": "/hub-http-janus/static-1.792",
  "hubspotter-http": "/hubspotter-http/static-1.4471",
  "immutable-less": "/immutable-less/static-1.4447",
  "marketplace-ui-client-types": "/marketplace-ui-client-types/static-1.16325",
  "nav-meta": "/nav-meta/static-1.28883",
  "react-window": "/react-window/static-1.13",
  "self-service-api": "/self-service-api/static-1.10025",
  "ui-addon-upgrades": "/ui-addon-upgrades/static-9.17645",
  "inbound-db-properties-service-client": "/inbound-db-properties-service-client/static-1.3668",
  "property-management-common": "/property-management-common/static-1.4599",
  "ui-addon-iframeable": "/ui-addon-iframeable/static-1.8838",
  "dispatcher": "/dispatcher/static-1.132",
  "general-store": "/general-store/static-6.20",
  "mobile-manifest-mixins": "/mobile-manifest-mixins/static-1.482",
  "module-federation": "/module-federation/static-1.18",
  "quartz-auth": "/quartz-auth/static-1.401",
  "quartz-head": "/quartz-head/static-1.391",
  "quartz-test": "/quartz-test/static-1.401",
  "quartz-tracking": "/quartz-tracking/static-1.105",
  "csstype": "/csstype/static-1.50",
  "bender-build-tools": "/bender-build-tools/static-1.2937",
  "autolinker": "/autolinker/static-3.11",
  "chatspot-core": "/chatspot-core/static-1.20273",
  "ContentUtils": "/ContentUtils/static-1.67601",
  "sassPrefix": "/sassPrefix/static-1.151",
  "avatar-components": "/avatar-components/static-1.2278",
  "customer-data-filters-ui": "/customer-data-filters-ui/static-1.38883",
  "customer-data-objects-ui-components": "/customer-data-objects-ui-components/static-1.12799",
  "customer-data-reference-ui-components": "/customer-data-reference-ui-components/static-1.12936",
  "embedded-academy-lib": "/embedded-academy-lib/static-1.13499",
  "ExportDialog": "/ExportDialog/static-6.10180",
  "highlight.js": "/highlight.js/static-1.74",
  "markdown-it": "/markdown-it/static-1.6",
  "reporting-action-components": "/reporting-action-components/static-1.40640",
  "reporting-snowflake": "/reporting-snowflake/static-1.55104",
  "reporting-ui-components": "/reporting-ui-components/static-2.63757",
  "reporting-visualizations": "/reporting-visualizations/static-1.58562",
  "ui-addon-teams": "/ui-addon-teams/static-1.21233",
  "magpie-lib": "/magpie-lib/static-1.5387",
  "magpie-types": "/magpie-types/static-1.4847",
  "simple-logging-lib": "/simple-logging-lib/static-1.2842",
  "navigation-components": "/navigation-components/static-1.17246",
  "ai-studio-lib": "/ai-studio-lib/static-1.10982",
  "developer-experience-shared-components": "/developer-experience-shared-components/static-1.10254",
  "transmute": "/transmute/static-2.85",
  "ui-addon-integrations-directory-panel": "/ui-addon-integrations-directory-panel/static-2.7782",
  "ui-tool-access": "/ui-tool-access/static-1.9938",
  "usage-based-billing-components-lib": "/usage-based-billing-components-lib/static-1.7983",
  "usage-tracker-anonymous": "/usage-tracker-anonymous/static-1.5545",
  "usage-tracker-public": "/usage-tracker-public/static-1.6939",
  "amplitude-session-replay-browser": "/amplitude-session-replay-browser/static-1.55",
  "inbound-db-meta-service-client": "/inbound-db-meta-service-client/static-1.3410",
  "persist-promise": "/persist-promise/static-1.3499",
  "reference-resolvers": "/reference-resolvers/static-1.7954",
  "ui-extensibility-client-types": "/ui-extensibility-client-types/static-1.3738",
  "hubspot-apollo-cache": "/hubspot-apollo-cache/static-1.132",
  "universal-page-editor-lib": "/universal-page-editor-lib/static-1.2792",
  "redux-toolkit": "/redux-toolkit/static-1.7",
  "simple-data-table": "/simple-data-table/static-1.2169",
  "merchandise-lib": "/merchandise-lib/static-1.259",
  "atom": "/atom/static-1.4862",
  "purchase-motions-components": "/purchase-motions-components/static-1.5476",
  "salesImages": "/salesImages/static-1.520",
  "batch-promise": "/batch-promise/static-1.1342",
  "crm-component-utils": "/crm-component-utils/static-1.38466",
  "crm-properties-common-lib": "/crm-properties-common-lib/static-1.5664",
  "framework-data-schema-resolvers": "/framework-data-schema-resolvers/static-1.6665",
  "reference-resolvers-lite": "/reference-resolvers-lite/static-1.7887",
  "navigation-messaging": "/navigation-messaging/static-1.6573",
  "hubspotter-http-shared-msw-handlers": "/hubspotter-http-shared-msw-handlers/static-1.9461",
  "cms-field-types": "/cms-field-types/static-1.4598",
  "content-icons-ui": "/content-icons-ui/static-1.2151",
  "conversations-skeleton-state": "/conversations-skeleton-state/static-1.7041",
  "crm-message-bus": "/crm-message-bus/static-1.42344",
  "customer-data-filters-ui-msw-helpers": "/customer-data-filters-ui-msw-helpers/static-1.21317",
  "customer-data-ui-utilities": "/customer-data-ui-utilities/static-1.9617",
  "FormUrlGenerator": "/FormUrlGenerator/static-2.4522",
  "framework-builder-read-service-client": "/framework-builder-read-service-client/static-1.3826",
  "framework-data-schema-quick-fetch": "/framework-data-schema-quick-fetch/static-1.6570",
  "multi-account-reference-resolvers": "/multi-account-reference-resolvers/static-1.767",
  "onboarding-tours": "/onboarding-tours/static-1.16248",
  "react-immutable-proptypes": "/react-immutable-proptypes/static-2.8",
  "reporting-datasets-permissions-lib": "/reporting-datasets-permissions-lib/static-1.13018",
  "academy-common-lib": "/academy-common-lib/static-1.12959",
  "content-assistance-lib": "/content-assistance-lib/static-1.7438",
  "dashboard-lib": "/dashboard-lib/static-1.80601",
  "file-manager-components": "/file-manager-components/static-1.22864",
  "getting-started-shared-tasks": "/getting-started-shared-tasks/static-1.17863",
  "hubspot-prosemirror": "/hubspot-prosemirror/static-1.17586",
  "hubspot-prosemirror-plugins": "/hubspot-prosemirror-plugins/static-1.17578",
  "prosemirror": "/prosemirror/static-1.13",
  "rich-text-lib": "/rich-text-lib/static-1.19458",
  "share-with-third-party-component-lib": "/share-with-third-party-component-lib/static-1.8484",
  "ui-addon-draggable": "/ui-addon-draggable/static-3.4558",
  "ui-asset-management-lib": "/ui-asset-management-lib/static-1.10700",
  "ui-business-units-lib": "/ui-business-units-lib/static-1.8819",
  "user-context": "/user-context/static-1.4889",
  "growth-payments-core": "/growth-payments-core/static-1.24709",
  "reporting-plugins": "/reporting-plugins/static-1.9974",
  "reporting-reports": "/reporting-reports/static-1.66164",
  "idb-keyval": "/idb-keyval/static-1.39",
  "reactive-lib": "/reactive-lib/static-1.518",
  "codemirror": "/codemirror/static-5.90",
  "feedback-loader": "/feedback-loader/static-1.28842",
  "react-codemirror": "/react-codemirror/static-1.10419",
  "apps-service-types": "/apps-service-types/static-1.3670",
  "oauth-service-types": "/oauth-service-types/static-1.4034",
  "onboarding-scopes": "/onboarding-scopes/static-1.6255",
  "onboarding-tours-client": "/onboarding-tours-client/static-1.4462",
  "platform-infra-nav-components": "/platform-infra-nav-components/static-1.7485",
  "subscription-experience-data-types": "/subscription-experience-data-types/static-1.14579",
  "crm-record-cards-service-types": "/crm-record-cards-service-types/static-1.3445",
  "location-customization-utils-lib": "/location-customization-utils-lib/static-1.8539",
  "redux-thunk": "/redux-thunk/static-2.43",
  "growth-monetization-service-types": "/growth-monetization-service-types/static-1.4307",
  "nav-client-types": "/nav-client-types/static-1.2149",
  "purchase-motions-api": "/purchase-motions-api/static-1.5479",
  "signup-constants": "/signup-constants/static-1.18376",
  "signup-ui-url-generator": "/signup-ui-url-generator/static-2.7858",
  "trials-service-types": "/trials-service-types/static-1.3708",
  "card-properties-lib": "/card-properties-lib/static-1.43500",
  "crm-actions": "/crm-actions/static-1.6093",
  "crm-cards-data": "/crm-cards-data/static-1.1195",
  "crm-cards-sdk": "/crm-cards-sdk/static-1.42897",
  "customer-data-properties": "/customer-data-properties/static-1.50782",
  "customer-data-properties-shared-msw-handlers": "/customer-data-properties-shared-msw-handlers/static-1.8790",
  "customer-data-tracking": "/customer-data-tracking/static-1.6673",
  "conditional-properties-service-client": "/conditional-properties-service-client/static-1.3616",
  "crm-pipelines-api-client-types": "/crm-pipelines-api-client-types/static-1.3957",
  "multi-currency-client-types": "/multi-currency-client-types/static-1.3510",
  "external-options-client-types": "/external-options-client-types/static-1.3977",
  "react-dnd-compat": "/react-dnd-compat/static-1.4414",
  "react-immutable-render-mixin": "/react-immutable-render-mixin/static-1.9",
  "growth-data-modal": "/growth-data-modal/static-1.5147",
  "growth-onboarding-confetti": "/growth-onboarding-confetti/static-1.2863",
  "growth-onboarding-next-action-utils": "/growth-onboarding-next-action-utils/static-1.1293",
  "onboarding-tours-utils": "/onboarding-tours-utils/static-1.314",
  "ui-shepherd-tracker": "/ui-shepherd-tracker/static-1.7319",
  "academy-service-client": "/academy-service-client/static-1.3473",
  "final-form": "/final-form/static-1.65",
  "zustand": "/zustand/static-1.51",
  "ui-coaching-tips": "/ui-coaching-tips/static-1.27925",
  "redux-actions": "/redux-actions/static-3.7",
  "ui-addon-opt": "/ui-addon-opt/static-4.8178",
  "video-components-external": "/video-components-external/static-1.10542",
  "video-data-lib": "/video-data-lib/static-1.34200",
  "emoji-mart": "/emoji-mart/static-3.4",
  "knowledge-content-types": "/knowledge-content-types/static-1.8361",
  "payment-link-components": "/payment-link-components/static-1.22923",
  "ui-addon-emoji-picker": "/ui-addon-emoji-picker/static-1.9681",
  "EmailSignatureEditor": "/EmailSignatureEditor/static-1.23894",
  "viral-links-lib": "/viral-links-lib/static-1.6825",
  "data-token-picker": "/data-token-picker/static-1.16030",
  "FileManagerLib": "/FileManagerLib/static-1.38504",
  "react-flip-move": "/react-flip-move/static-1.65",
  "timezone-utils": "/timezone-utils/static-2.5037",
  "getting-started-shared-tasks-store": "/getting-started-shared-tasks-store/static-1.16981",
  "campaign-roi-lib": "/campaign-roi-lib/static-1.8254",
  "diff-match-patch": "/diff-match-patch/static-1.7",
  "browser-eslint": "/browser-eslint/static-2.57",
  "edison-service-client-types": "/edison-service-client-types/static-1.182",
  "eligibility-engine-service-types": "/eligibility-engine-service-types/static-1.2989",
  "crm_data": "/crm_data/static-4.91193",
  "crm-links": "/crm-links/static-1.6056",
  "customer-data-sidebar": "/customer-data-sidebar/static-2.45400",
  "enrichment-properties-lib": "/enrichment-properties-lib/static-1.15003",
  "crm-fe-perf": "/crm-fe-perf/static-1.22697",
  "calling-global-api": "/calling-global-api/static-1.63644",
  "calling-internal-common": "/calling-internal-common/static-1.31086",
  "calling-lifecycle-internal": "/calling-lifecycle-internal/static-1.65026",
  "calling-lifecycle-messages": "/calling-lifecycle-messages/static-1.57320",
  "commerce-products-lib": "/commerce-products-lib/static-1.8845",
  "google-libphonenumber": "/google-libphonenumber/static-1.33",
  "hs-entities": "/hs-entities/static-1.470",
  "inbounddb-objects-service-types": "/inbounddb-objects-service-types/static-1.4042",
  "meetings-icalendar-utils-lib": "/meetings-icalendar-utils-lib/static-1.425",
  "object-builder-ui-client": "/object-builder-ui-client/static-1.47948",
  "pipeline-validation-client-types": "/pipeline-validation-client-types/static-1.3779",
  "property-value-citations": "/property-value-citations/static-1.1396",
  "pulse": "/pulse/static-1.303",
  "smart-property-lib": "/smart-property-lib/static-1.5885",
  "tiered-pricing": "/tiered-pricing/static-1.820",
  "ui-addon-form-validation": "/ui-addon-form-validation/static-1.10787",
  "growth-onboarding-feedback-components": "/growth-onboarding-feedback-components/static-1.6377",
  "content-media-composition-data-lib": "/content-media-composition-data-lib/static-1.11428",
  "content-media-compositions": "/content-media-compositions/static-2.15435",
  "media-bridge-lib": "/media-bridge-lib/static-1.18553",
  "commerce-tours-lib": "/commerce-tours-lib/static-1.5709",
  "growth-onboarding-reliability": "/growth-onboarding-reliability/static-1.4879",
  "sales-checkout-service-client": "/sales-checkout-service-client/static-1.3462",
  "draft-convert": "/draft-convert/static-2.67",
  "draft-extend": "/draft-extend/static-3.70",
  "draft-js": "/draft-js/static-5.72",
  "draft-plugins": "/draft-plugins/static-2.21296",
  "sales-email-signature-service-client": "/sales-email-signature-service-client/static-1.3637",
  "audio-components": "/audio-components/static-1.5602",
  "FileManagerCore": "/FileManagerCore/static-1.38363",
  "FileManagerImages": "/FileManagerImages/static-1.36015",
  "video-components": "/video-components/static-1.12545",
  "crm_universal": "/crm_universal/static-1.21649",
  "customer-data-email": "/customer-data-email/static-1.17659",
  "calling-error-reporting": "/calling-error-reporting/static-1.31092",
  "card-payment-highlight-lib": "/card-payment-highlight-lib/static-1.36485",
  "card-subscription-highlight-lib": "/card-subscription-highlight-lib/static-1.38841",
  "commerce-billing-lib": "/commerce-billing-lib/static-1.18483",
  "commerce-contract-lib": "/commerce-contract-lib/static-1.11158",
  "customer-data-content": "/customer-data-content/static-1.26859",
  "invoices-highlight-card-lib": "/invoices-highlight-card-lib/static-1.54004",
  "orders-highlight-card-lib": "/orders-highlight-card-lib/static-1.20851",
  "products-highlight-card-lib": "/products-highlight-card-lib/static-1.17129",
  "project-storage": "/project-storage/static-1.4524",
  "quotes-highlight-card-lib": "/quotes-highlight-card-lib/static-1.71152",
  "breeze-intelligence-kit": "/breeze-intelligence-kit/static-1.5311",
  "crm-source-interpretation-lib": "/crm-source-interpretation-lib/static-1.5121",
  "framework-data-schema-resolvers-shared-msw-handlers": "/framework-data-schema-resolvers-shared-msw-handlers/static-1.9546",
  "policy-lib": "/policy-lib/static-1.6578",
  "shared-worker-versioning": "/shared-worker-versioning/static-1.10830",
  "calling-usage-tracker": "/calling-usage-tracker/static-1.6332",
  "voice-sms-access-library": "/voice-sms-access-library/static-1.224",
  "products-iframe-lib": "/products-iframe-lib/static-1.7294",
  "products-ui-components-shared-msw-handlers": "/products-ui-components-shared-msw-handlers/static-1.9845",
  "directed-graph": "/directed-graph/static-1.730",
  "event-emitter": "/event-emitter/static-1.740",
  "react-tinymce": "/react-tinymce/static-1.54598",
  "reference-resolvers-lite-shared-msw-handlers": "/reference-resolvers-lite-shared-msw-handlers/static-1.9609",
  "tinymce": "/tinymce/static-5.11",
  "tinymce-config": "/tinymce-config/static-2.53724",
  "tinymce-plugins": "/tinymce-plugins/static-1.56838",
  "tinymce-themes": "/tinymce-themes/static-1.55694",
  "hls.js": "/hls.js/static-1.34",
  "js-cookie": "/js-cookie/static-1.18",
  "cropperjs": "/cropperjs/static-1.10",
  "urlinator": "/urlinator/static-1.4325",
  "video-embed": "/video-embed/static-1.35034",
  "social-insights-client-types": "/social-insights-client-types/static-1.21303",
  "sequences-lib": "/sequences-lib/static-1.7679",
  "ui-gdpr-components": "/ui-gdpr-components/static-1.10140",
  "commerce-shared-components-lib": "/commerce-shared-components-lib/static-1.17898",
  "commerce-subscription-lib": "/commerce-subscription-lib/static-1.36418",
  "commerce-tools-ui-lib": "/commerce-tools-ui-lib/static-1.9774",
  "utility-belt": "/utility-belt/static-1.2334",
  "payments-enrollment-embed-lib": "/payments-enrollment-embed-lib/static-1.22007",
  "products-ui-components": "/products-ui-components/static-1.39364",
  "quotes-client-types": "/quotes-client-types/static-1.37240",
  "quotes-ui-lib": "/quotes-ui-lib/static-1.79871",
  "SalesContentIndexUI": "/SalesContentIndexUI/static-3.8892",
  "accounting-integrations-ui-components": "/accounting-integrations-ui-components/static-1.6713",
  "invoices-ui-lib": "/invoices-ui-lib/static-1.54020",
  "commerce-products-api": "/commerce-products-api/static-1.1948",
  "SafeStorage": "/SafeStorage/static-1.4197",
  "invoices-iframe-lib": "/invoices-iframe-lib/static-1.56078",
  "quotes-modal-lib": "/quotes-modal-lib/static-1.101828",
  "calling-orchestration-schema": "/calling-orchestration-schema/static-1.35001",
  "sales-views-client-types": "/sales-views-client-types/static-1.4080",
  "hub-http-contrib": "/hub-http-contrib/static-1.2837",
  "interframe": "/interframe/static-3.4583",
  "tinymce-data": "/tinymce-data/static-1.39809",
  "ui-addon-sales-email": "/ui-addon-sales-email/static-1.5006",
  "layout-dnd-components": "/layout-dnd-components/static-1.12021",
  "layout-dnd-utils": "/layout-dnd-utils/static-1.10996",
  "ui-brand-identity-lib": "/ui-brand-identity-lib/static-1.13853",
  "NamespacedHubStyle": "/NamespacedHubStyle/static-2.8889",
  "outpost": "/outpost/static-1.3998",
  "sequences-client-types-lib": "/sequences-client-types-lib/static-1.7536",
  "customer-data-associations": "/customer-data-associations/static-1.7130",
  "framework-data-table": "/framework-data-table/static-2.11399",
  "customer-data-rte": "/customer-data-rte/static-1.32427",
  "cv-backend-services": "/cv-backend-services/static-1.1504",
  "growth-onboarding-empty-states": "/growth-onboarding-empty-states/static-1.5354",
  "InboxConnectUtils": "/InboxConnectUtils/static-4.14207",
  "payments-post-enroll-local-storage-lib": "/payments-post-enroll-local-storage-lib/static-1.4904",
  "qrcode-generator": "/qrcode-generator/static-1.64",
  "stripe-embedded-components": "/stripe-embedded-components/static-1.7122",
  "commerce-permissions": "/commerce-permissions/static-1.547",
  "commerce-tax-lib": "/commerce-tax-lib/static-1.310",
  "property-description-translator": "/property-description-translator/static-1.3651",
  "FireAlarmUi": "/FireAlarmUi/static-1.4322",
  "sales-templates-service-types-lib": "/sales-templates-service-types-lib/static-1.3984",
  "commerce-analytics-service-client": "/commerce-analytics-service-client/static-1.3450",
  "totals-ui-components": "/totals-ui-components/static-1.22981",
  "ContentData": "/ContentData/static-1.67676",
  "layout-data-lib": "/layout-data-lib/static-1.9321",
  "deal-intel-decorators": "/deal-intel-decorators/static-1.1238",
  "tanstack-virtual": "/tanstack-virtual/static-1.25",
  "draft-content-plugins": "/draft-content-plugins/static-1.27696",
  "stripe-connect-js": "/stripe-connect-js/static-1.64",
  "commerce-totals-service-types": "/commerce-totals-service-types/static-1.3630",
  "advanced-menus-core": "/advanced-menus-core/static-1.14804",
  "advanced-menus-lib": "/advanced-menus-lib/static-1.11779",
  "ui-memberships-settings-lib": "/ui-memberships-settings-lib/static-1.33408",
  "deal-intel-utils": "/deal-intel-utils/static-1.1242",
  "seamless-immutable": "/seamless-immutable/static-7.6",
  "simple-menus-core": "/simple-menus-core/static-1.14803",
  "simple-menus-lib": "/simple-menus-lib/static-1.16320"
}
};
